<script setup lang="ts">
import type {
  IExchangeMetalPrice,
  IExchangeMetalPriceResponse
} from '~/components/widget/sidebar-gold-price/types'

const { t } = useI18n()

const { data } = await useApi<IExchangeMetalPriceResponse>(() => '/gold-bars/latest', {
  key: 'gold-price-sidebar-widget'
})

const tabs = [
  { key: 'regular', label: t('widget.sidebar_gold_price.tabs.regular') },
  { key: 'refined', label: t('widget.sidebar_gold_price.tabs.refined') }
]

const goldData = computed(() =>
  tabs.map(({ key, label }) => ({
    value: key,
    label,
    items: (data.value?.data?.[key] ?? []) as IExchangeMetalPrice[]
  }))
)
</script>

<template>
  <div v-if="data.data" class="flex flex-col gap-4">
    <div v-for="tab in goldData" :key="tab.value" :value="tab.value">
      <Heading tag="h6"
        >{{ tab.label }}
        <span class="text-xs font-normal text-gray-500"
          >{{ $t('common.from_amount') }} {{ tab.items[0].date }}</span
        ></Heading
      >
      <table class="mt-2 w-full">
        <thead>
          <tr v-if="tab.value === 'regular'">
            <th class="py-1.5 text-right text-xs font-normal leading-3 text-gray-500">
              {{ $t('widget.sidebar_gold_price.table_headers.mass') }}
            </th>
            <th class="py-1.5 text-right text-xs font-normal leading-3 text-gray-500">
              {{ $t('common.buy') }}
            </th>
            <th class="py-1.5 text-right text-xs font-normal leading-3 text-gray-500">
              {{ $t('common.sell') }}
            </th>
          </tr>
          <tr v-else>
            <th class="py-1.5 text-left text-xs font-normal leading-3 text-gray-500">
              {{ $t('widget.sidebar_gold_price.table_headers.bar_number') }}
            </th>
            <th class="py-1.5 text-right text-xs font-normal leading-3 text-gray-500">
              {{ $t('widget.sidebar_gold_price.table_headers.mass') }}
            </th>
            <th class="py-1.5 text-right text-xs font-normal leading-3 text-gray-500">
              {{ $t('widget.sidebar_gold_price.table_headers.price') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in tab.items" :key="item.id">
            <template v-if="tab.value === 'regular'">
              <td class="text-md py-2 text-right">
                {{ useNumberFormat(item.mass) }} {{ $t('widget.sidebar_gold_price.units.grams') }}
              </td>
              <td class="py-2 text-right font-semibold">
                {{ useCurrencyFormat(item.buy_price, 1) }}
              </td>
              <td class="py-2 text-right font-semibold">
                {{ useCurrencyFormat(item.sell_price, 1) }}
              </td>
            </template>

            <template v-else>
              <td class="text-md py-2">
                {{ item.name }}
              </td>
              <td class="py-2 text-right font-semibold">
                {{ useNumberFormat(item.mass) }} {{ $t('widget.sidebar_gold_price.units.grams') }}
              </td>
              <td class="py-2 text-right font-semibold">
                {{ useCurrencyFormat(item.sell_price, 1) }}
              </td>
            </template>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
